<div class="w-full flex justify-center">
  <div class="max-w-[1800px] w-full">
    <zaeper-page-layout [title]="('manage-groups' | zDictionary)" [pageLayout]="ePageLayout.CARDS" [navigation]="navigation">
      <ng-template zTemplate="header">
        <zaeper-icon fontSet="material-icons-outlined">location_on</zaeper-icon>
      </ng-template>

      <div class="flex flex-col gap-6">
        <div class="flex justify-between">
          <!-- TabNavigation -->
          <div class="flex flex-row gap-2">
            <!-- Shown to everyone, disabled with the role it needs: users see what their role can't do. -->
            <span class="inline-flex" [pTooltip]="(isManager$ | async) ? undefined : ('MANAGER' | zRole: 'hint')" tooltipPosition="top">
              <p-button [disabled]="!(isManager$ | async)" icon="pi pi-plus" (onClick)="openCreateModal()" [rounded]="true"
            [label]="'add-group' | zDictionary"></p-button>
            </span>
          </div>

          <p-iconfield class="self-center">
            <p-inputicon styleClass="pi pi-search"/>
            <input pInputText type="text" [placeholder]="'search' | zDictionary: 'main'" #globalFilter/>
          </p-iconfield>
        </div>

        <p-table [paginator]="true" [rows]="10" [rowsPerPageOptions]="rowsPerPageOptions"
          [totalRecords]="(totalRecords$ | async) || 0" [lazy]="true" (onLazyLoad)="lazyLoadTable($event)"
          [loading]="(isLoading$ | async) ?? true" [showLoader]="false" [value]="(records$ | async) || []"
          [tableStyle]="{ 'min-width': '50rem' }">
          <ng-template pTemplate="loadingbody" let-columns="columns">
            @for (i of (skeletonRows$ | async); track i) {
              <tr>
                <td>
                  <p-skeleton height="2rem"></p-skeleton>
                </td>
                <td>
                  <p-skeleton height="2rem"></p-skeleton>
                </td>
                <td>
                  <p-skeleton height="2rem"></p-skeleton>
                </td>
                <td>
                  <p-skeleton height="2rem"></p-skeleton>
                </td>
              </tr>
            }
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th class="w-1/2">Beschreibung</th>
              <th>Aktionen</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-groupRecord let-i="rowIndex">
            <tr>
              <td>{{ i + 1 }}</td>
              <td><strong>{{ groupRecord.name }}</strong></td>
              <td [ngClass]="{'text-surface-400 dark:text-surface-500': !groupRecord.description}"><i>{{ groupRecord.description ?? "Keine Beschreibung vorhanden" }}</i></td>
              <td class="flex gap-2 justify-end">
                @if (((totalRecords$ | async) || 0) > 1) {
                  <span class="inline-flex" [pTooltip]="(isManager$ | async) ? undefined : ('MANAGER' | zRole: 'hint')" tooltipPosition="top">
                    <p-button [disabled]="!(isManager$ | async)" (onClick)="delete(groupRecord.id)" icon="pi pi-trash"
                    severity="danger" [outlined]="true"
                    [rounded]="true"/>
                  </span>
                }
                <span class="inline-flex" [pTooltip]="(isManager$ | async) ? undefined : ('MANAGER' | zRole: 'hint')" tooltipPosition="top">
                  <p-button [disabled]="!(isManager$ | async)" (onClick)="update(groupRecord)" icon="pi pi-pencil" [outlined]="true" [rounded]="true"/>
                </span>
                <p-button (onClick)="switchToGroup(groupRecord)"
                  [outlined]="true"
                  [rounded]="true" icon="pi pi-arrow-right-arrow-left"/>
                <p-button [routerLink]="['/de/clouds/' + cloudId + '/groups/' + groupRecord.id + '/receivers']" [rounded]="true">Receivers verwalten</p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>

      </div>
    </zaeper-page-layout>
  </div>
</div>
